
var urlparams = {};
var x = document.location.search.substring(1).split("&");
for (var i in x) {
    var z = x[i].split("=", 2);
    urlparams[z[0]] = unescape(z[1]);
}

if (!('BigInt' in window)) {
    window.BigInt = (x) => Number(x);
    BigInt.asUintN = (_, x) => x;
}

var authentication = {
    isAdmin: false,
    isAdminOrLoginAs: false,
};
window.authentication = authentication;

$(document).ready(function() {
    document.body.style.overflow = 'scroll';
    var scrollWidth = window.innerWidth - document.body.clientWidth;
    document.body.style.setProperty('--scrollbar-width', scrollWidth + 'px');
    document.body.style.overflow = 'auto';

    $('.back-button').click(function(ev) {
        history.back();
        return false;
    });

    var testsystemInfo = $('#testsystem-info');
    testsystemInfo.click(function(ev) {
        var hideUntil = moment();
        hideUntil.add(6, 'hours');
        window.localStorage.setItem('testsystem', hideUntil.unix());
        messaging.showGlobalMessage('success', null, 'Die Meldung wird für 6 Stunden ausgeblendet.');
        testsystemInfo.addClass('d-none');
        return false;
    });
    var testsystemTS = parseInt(window.localStorage.getItem('testsystem') || 0);
    if (testsystemTS === 0 || testsystemTS < moment().unix()) {
        testsystemInfo.removeClass('d-none');
    }

    setInterval(function() {
        connection.getJson('/Auth/Ping', {
            onError: function() {},
        });
    }, 5 * 60000); // ping all 5 minutes

    var body = $('body');

    authentication.isAdmin = body.is('[data-admin]');
    authentication.isAdminOrLoginAs = body.is('[data-adminOrLoginAs]');

    onContentReady(body);

    if (window.slidein) {
        $(slidein).on('onResized', function () {
            registerFixedTableHeaders($('body'));
        });
    }
});
$(window).resize(function() {
    registerFixedTableHeaders($('body'));
});

function onContentReady(container) {
    // magnific popup
    $(document).trigger('content-ready', [container]);
    if ($.fn.magnificPopup) {
        container.find('.magnific-image').magnificPopup({type: 'image'});
        container.find('.magnific-video').magnificPopup({type: 'iframe'});
        container.find('.magnific-gallery').each(function () {
            $(this).magnificPopup({
                type: 'image',
                delegate: 'a',
                gallery: {
                    enabled: true,
                    navigateByImgClick: true,
                    preload: [0, 1],
                    tPrev: 'Zurück',
                    tNext: 'Vorwärts',
                    tCounter: '%curr% von %total%'
                }
            });
        });
        container.find('.magnific-iframe').magnificPopup({type: 'iframe'});
    }

    $('[data-href]').click(function(ev) {
        location.href = $(this).attr('data-href');
        return false;
    });
    registerFixedTableHeaders(container);

    container.find('.dropdown-submenu a').on("click", function(e){
        $(this).next('ul').toggle();
        e.stopPropagation();
        e.preventDefault();
    });

    container.find('.view-password').each(function() {
        var me = $(this);
        var input = me.find('input');
        me.find('.btn').click(function() {
            if (input.attr("type") === "password") {
                input.attr("type", "text");
                me.find('i').removeClass('fa-eye').addClass('fa-eye-slash');
            } else {
                input.attr("type", "password");
                me.find('i').addClass('fa-eye').removeClass('fa-eye-slash');
            }
            return false;
        });
    });

    container.find('[data-copy]').click(function() {
        var me = $(this);
        copyTextToClipboard(me.attr('data-copy'));
        toastr.info("Der Link wurde in die Zwischenablage kopiert.", "Ok", {});
    });

    container.find('[data-toggle="tooltip"]').tooltip();

    container.find('.send-error').on('click', function() {
        var popup = notification.notifyPopup("Helpdesk", "", {
            spinner: true,
            width: '600px',
            dialogCssClass: 'modal-dialog-scrollable',
        });
        connection.getHtmlPart("/Help/ErrorMailForm", {
            onSuccess: function(data) {
                var notifyBody = popup.find('.modal-body');
                notifyBody.addClass('p-0').html(data);
                popup.find('form').submit(function(ev) {
                    ev.preventDefault();
                    var btn = popup.find('[type="submit"]');
                    btn.attr("disabled", "disabled");
                    var field = popup.find('#message');
                    popup.find('.is-invalid').removeClass('is-invalid');
                    popup.find('.invalid-feedback').remove();
                    var message = field.val();
                    if (message.trim() !== "") {
                        console.log('senden');
                        connection.getJson("/Help/ErrorMailForm", {
                            type: 'post',
                            timeout: 20000,
                            data: {
                                message: message,
                                file: popup.find('[name="attachment"]').val(),
                                type: popup.find('[name="type"]').val(),
                                debugInfos: {
                                    URL: window.location.href,
                                    UserAgent: window.navigator.userAgent,
                                    ScreenSize: window.screen.width + " / " + window.screen.height,
                                    BrowserSize: window.innerWidth + "/" + window.innerHeight,
                                },
                            },
                            onSuccess: function () {
                                messaging.showGlobalMessage('success', null, 'Deine Nachricht wurde übermittelt.');
                                notification.close(popup);
                            }
                        });
                    } else {
                        var container = field.parent();
                        container.addClass('is-invalid');
                        container.append($('<div class="invalid-feedback">Erfasse eine Nachricht.</div>'));
                        btn.attr("disabled", null);
                    }
                    return false;
                });
                var dzEl = popup.find('[data-upload-container]');
                dzEl.on('file-added', function(e, data) {
                    var value = popup.find('[name="attachment"]').val();
                    dzEl.find('.dz-clickable span').remove();
                    dzEl.find('.dz-clickable').append($(`<div>${data.file.name}</div>`));
                    popup.find('[name="attachment"]').val(value + "," + data.response.filename);
                });
                onContentReady(popup);
            }
        });
    });
}
window.onContentReady = onContentReady;

function registerFixedTableHeaders(container) {
    var tableHeaders = container.find('thead[data-fixed-header-sync]');
    $.each(tableHeaders, function() {
        var tableHeader = $(this);

        var headerContainer = $(tableHeader.attr('data-fixed-header-sync'));
        var tableColumns = tableHeader.find('.header.sync-widths td');
        if (headerContainer.find('thead').length === 0) {
            headerContainer.append(tableHeader.clone());
            $.each(headerContainer.find('td[data-text]'), function() {
                if ($(this).attr('data-text')) {
                    $(this).html($(this).attr('data-text'));
                }
            });
        }
        var headerColumns = headerContainer.find('tr.sync-widths td');
        $.each(tableColumns, function(i) {
            var tableColumn = $(this);
            $(headerColumns[i]).css({
                width: tableColumn.outerWidth(),
                maxWidth: tableColumn.outerWidth(),
            });
        });
    });
}
window.registerFixedTableHeaders = registerFixedTableHeaders;

function fallbackCopyTextToClipboard(text) {
    var textArea = document.createElement("textarea");
    textArea.value = text;

    // Avoid scrolling to bottom
    textArea.style.top = "0";
    textArea.style.left = "0";
    textArea.style.position = "fixed";

    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();

    try {
        var successful = document.execCommand('copy');
        var msg = successful ? 'successful' : 'unsuccessful';
        console.log('Fallback: Copying text command was ' + msg);
    } catch (err) {
        console.error('Fallback: Oops, unable to copy', err);
    }

    document.body.removeChild(textArea);
}

function copyTextToClipboard(text) {
    if (!navigator.clipboard) {
        fallbackCopyTextToClipboard(text);
        return;
    }
    navigator.clipboard.writeText(text).then(function() {
        console.log('Async: Copying to clipboard was successful!');
    }, function(err) {
        console.error('Async: Could not copy text: ', err);
    });
}
window.copyTextToClipboard = copyTextToClipboard;

window.mapStyle = [
    {
        "featureType": "road",
        "elementType": "geometry",
        "stylers": [
            {
                "lightness": 100
            },
            {
                "visibility": "simplified"
            }
        ]
    },
    {
        "featureType": "water",
        "elementType": "geometry",
        "stylers": [
            {
                "visibility": "on"
            },
            {
                "color": "#C6E2FF"
            }
        ]
    },
    {
        "featureType": "poi",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "color": "#C5E3BF"
            }
        ]
    },
    {
        "featureType": "road",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "color": "#D1D1B8"
            }
        ]
    }
];